export default "__VITE_ASSET__CTHcMy1i__"